import styled from 'styled-components';

export default styled.div`
  padding: 10px 10px 0;
  cursor: pointer;
`;
